import React, { useState, useEffect } from 'react';
import JoinTelegramModal from '../../../../components/common/joinTelegramModal';
import GaEventsTracker from "../../../../components/common/GaEventsTracker";

const DesktopTab = ({ Open, OpenModal, OnClickPopHandle }) => {

    const useGaEventsTracker = GaEventsTracker("External Links")
    const [openLive, setOpenLive] = useState(false)

    const TelegramWeb = () => {
        OnClickPopHandle("https://www.moomoo.com/community/profile/macquarie-warrants-malaysia-80001374", true)
        useGaEventsTracker('event', 'visitWeb', { 'event_category': 'Telegram' })
    }

    const ClickhereD = () => {
        OnClickPopHandle("https://web.telegram.org/#/im?p=@Malaysiawarrants", true)
        useGaEventsTracker('event', 'openOnWeb', { 'event_category': 'Telegram' })
    }

    return (
        <>
            <div className="activeD">
                <div className="row step-row">
                    <div className="col-md-1  col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_1.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11 col-xs-9">
                        <p className="howJoinSubTitle">Click the link below</p>
                        <div>
                            <span
                                className="telegramWeb broker_img"
                                onClick={TelegramWeb}
                            >
                                <img
                                    className="forMDimg"
                                    src="/img/moocommunity/1737361903349122.jpg"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row step-row">
                    <div className="col-md-1 col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_2.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11 col-xs-9">
                        <p className="howJoinSubTitle">
                            Sign up with your mobile number/email address
                        </p>
                        <img
                            className="for-img forMDimg"
                            src="/img/moocommunity/MooComm_Sign_Up_Desktop_1.png"
                        />
                    </div>
                </div>
                <div className="row step-row">
                    <div className="col-md-1 col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_3.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11  col-xs-9">
                        <p className="howJoinSubTitle custom" style={{ marginTop: '0px' }}>
                            Tap on the +Follow button next to the account name.
                            {/* <span
                                onClick={() => setOpenLive(true)}
                                className="clickhereD broker_img"
                                style={{ color: "#0675C2" }}
                                onClick={ClickhereD}
                            >
                                click here
                            </span> */}
                        </p>
                        <img
                            className="for-img forMDimg"
                            src="/img/moocommunity/MooComm_Sign_Up_Desktop_2.png"
                            style={{ marginTop: '10px' }}
                        />
                    </div>
                </div>
                {/* <div className="row step-row">
                    <div className="col-md-1">
                        <img src="/img/telegram/section1/no4.png" />
                    </div>
                    <div className="col-md-11">
                        <p className="howJoinSubTitle">
                            Tap on the join button at the bottom of your screen
                        </p>
                    </div>
                </div> */}

            </div>
        </>
    )
};

export default DesktopTab;